module.exports = __webpack_public_path__ + "static/media/fast-forward.9d7e8da6.svg";